import React from 'react'
import { useSetRecoilState } from 'recoil'
import { openModalState } from 'recoils/atoms'

import Confirmation from './Confirmation'
import Modal from './Modal'

type ModalConfirmProps = {
  isOpen: boolean
  onConfirm: () => void
  onClose: () => void
  title: string
  decs: string
  textBtnConfirm: string
  textBtnCancel?: string
  isLoading?: boolean
}

export const ModalConfirm = (props: ModalConfirmProps): JSX.Element => {
  const setIsOpenModal = useSetRecoilState(openModalState)

  const {
    isOpen,
    onConfirm,
    onClose,
    title,
    decs,
    textBtnConfirm,
    textBtnCancel,
    isLoading,
  } = props

  const handleClose = () => {
    setIsOpenModal(false)
    onClose()
  }

  return (
    <Modal isPrompt isIcon={false} isOpen={isOpen} onClose={onClose}>
      <Confirmation
        title={title}
        description={decs}
        confirmText={textBtnConfirm}
        cancelText={textBtnCancel}
        isLoading={isLoading}
        onConfirm={onConfirm}
        onClose={handleClose}
      />
    </Modal>
  )
}
